(function () {
  function init() {
    const notice = document.querySelector('[data-order-notice]');
    if (!notice || !notice.dataset.customerId) return;
    const text = notice.dataset.noticeText || '';
    const scope = 'sayora_order_notice:' + notice.dataset.customerId;
    const readKey = scope + ':read';
    const dismissedKey = scope + ':dismissed';
    const memory = new Map();
    const read = key => {
      if (memory.has(key)) return memory.get(key);
      try { return localStorage.getItem(key); } catch (_) {}
      try { return sessionStorage.getItem(key); } catch (_) {}
      return null;
    };
    const save = key => {
      memory.set(key, text);
      try { localStorage.setItem(key, text); } catch (_) {
        try { sessionStorage.setItem(key, text); } catch (_) {}
      }
    };
    const details = document.querySelector('.order-updates-card');
    function update() {
      if (details && document.visibilityState !== 'hidden') save(readKey);
      const unread = !!text && read(readKey) !== text;
      document.querySelectorAll('[data-order-unread]').forEach(badge => { badge.hidden = !unread; });
      notice.hidden = !!details || !unread || read(dismissedKey) === text;
    }
    const dismiss = notice.querySelector('[data-order-notice-dismiss]');
    if (dismiss) dismiss.addEventListener('click', function () { save(dismissedKey); update(); });
    window.addEventListener('storage', function (event) {
      if (event.key === readKey || event.key === dismissedKey || event.key === null) {
        if (event.key === null) memory.clear(); else memory.delete(event.key);
        update();
      }
    });
    window.addEventListener('pageshow', update);
    window.addEventListener('focus', function () { memory.clear(); update(); });
    document.addEventListener('visibilitychange', update);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
